var map = {
	"./3g2.svg": 47027,
	"./3ga.svg": 59550,
	"./3gp.svg": 20326,
	"./7z.svg": 74518,
	"./aa.svg": 29271,
	"./aac.svg": 12477,
	"./ac.svg": 52801,
	"./accdb.svg": 5882,
	"./accdt.svg": 56339,
	"./ace.svg": 83554,
	"./adn.svg": 84772,
	"./ai.svg": 43952,
	"./aif.svg": 24611,
	"./aifc.svg": 69284,
	"./aiff.svg": 51424,
	"./ait.svg": 68666,
	"./amr.svg": 90579,
	"./ani.svg": 16482,
	"./apk.svg": 26520,
	"./app.svg": 34987,
	"./applescript.svg": 32969,
	"./asax.svg": 91287,
	"./asc.svg": 53172,
	"./ascx.svg": 75513,
	"./asf.svg": 51859,
	"./ash.svg": 6705,
	"./ashx.svg": 23320,
	"./asm.svg": 60274,
	"./asmx.svg": 19943,
	"./asp.svg": 4462,
	"./aspx.svg": 48017,
	"./asx.svg": 20274,
	"./au.svg": 9121,
	"./aup.svg": 36259,
	"./avi.svg": 81947,
	"./axd.svg": 99926,
	"./aze.svg": 33654,
	"./bak.svg": 16190,
	"./bash.svg": 58708,
	"./bat.svg": 4418,
	"./bin.svg": 58077,
	"./blank.svg": 79940,
	"./bmp.svg": 11218,
	"./bowerrc.svg": 86374,
	"./bpg.svg": 11198,
	"./browser.svg": 56799,
	"./bz2.svg": 37476,
	"./bzempty.svg": 99904,
	"./c.svg": 2772,
	"./cab.svg": 64934,
	"./cad.svg": 36771,
	"./caf.svg": 18158,
	"./cal.svg": 42992,
	"./cd.svg": 17953,
	"./cdda.svg": 62079,
	"./cer.svg": 1652,
	"./cfg.svg": 89134,
	"./cfm.svg": 60673,
	"./cfml.svg": 65086,
	"./cgi.svg": 95497,
	"./chm.svg": 23240,
	"./class.svg": 4162,
	"./cmd.svg": 35370,
	"./code-workspace.svg": 43485,
	"./codekit.svg": 40870,
	"./codekit3.svg": 50675,
	"./coffee.svg": 67326,
	"./coffeelintignore.svg": 66512,
	"./com.svg": 30182,
	"./compile.svg": 30459,
	"./conf.svg": 62629,
	"./config.svg": 45791,
	"./cpp.svg": 26995,
	"./cptx.svg": 51646,
	"./cr2.svg": 67775,
	"./crdownload.svg": 96825,
	"./crt.svg": 80476,
	"./crypt.svg": 34612,
	"./cs.svg": 27556,
	"./csh.svg": 68800,
	"./cson.svg": 58033,
	"./csproj.svg": 23308,
	"./css.svg": 34584,
	"./csv.svg": 49039,
	"./cue.svg": 20117,
	"./cur.svg": 28628,
	"./dart.svg": 25532,
	"./dat.svg": 80588,
	"./data.svg": 29003,
	"./db.svg": 49440,
	"./dbf.svg": 75325,
	"./deb.svg": 70743,
	"./dgn.svg": 82174,
	"./dist.svg": 61050,
	"./diz.svg": 749,
	"./dll.svg": 37882,
	"./dmg.svg": 6938,
	"./dng.svg": 65818,
	"./doc.svg": 24112,
	"./docb.svg": 97670,
	"./docm.svg": 32735,
	"./docx.svg": 28841,
	"./dot.svg": 19098,
	"./dotm.svg": 33544,
	"./dotx.svg": 36397,
	"./download.svg": 20639,
	"./dpj.svg": 72300,
	"./ds_store.svg": 5907,
	"./dsn.svg": 67492,
	"./dst.svg": 56005,
	"./dtd.svg": 51797,
	"./dwg.svg": 57029,
	"./dxf.svg": 26593,
	"./editorconfig.svg": 30735,
	"./el.svg": 79524,
	"./elf.svg": 34265,
	"./eml.svg": 31401,
	"./enc.svg": 59040,
	"./eot.svg": 51810,
	"./eps.svg": 62421,
	"./epub.svg": 39978,
	"./eslintignore.svg": 38696,
	"./exe.svg": 82252,
	"./f4v.svg": 32802,
	"./fax.svg": 79622,
	"./fb2.svg": 82841,
	"./fla.svg": 54722,
	"./flac.svg": 87707,
	"./flv.svg": 24336,
	"./fnt.svg": 65031,
	"./fon.svg": 57466,
	"./gadget.svg": 70995,
	"./gdp.svg": 18748,
	"./gem.svg": 26965,
	"./gif.svg": 44790,
	"./gitattributes.svg": 85388,
	"./gitignore.svg": 80147,
	"./go.svg": 22063,
	"./gpg.svg": 42112,
	"./gpl.svg": 42608,
	"./gradle.svg": 60742,
	"./gz.svg": 47131,
	"./h.svg": 67984,
	"./handlebars.svg": 88285,
	"./hbs.svg": 51990,
	"./heic.svg": 61691,
	"./hlp.svg": 92466,
	"./hs.svg": 52485,
	"./hsl.svg": 87338,
	"./htm.svg": 52675,
	"./html.svg": 64144,
	"./ibooks.svg": 16204,
	"./icma.svg": 99371,
	"./icml.svg": 69322,
	"./icns.svg": 13676,
	"./ico.svg": 67863,
	"./ics.svg": 88376,
	"./idx.svg": 94382,
	"./ifc.svg": 23810,
	"./iff.svg": 71833,
	"./ifo.svg": 92331,
	"./image.svg": 72904,
	"./img.svg": 58666,
	"./iml.svg": 75966,
	"./in.svg": 43908,
	"./inc.svg": 65926,
	"./indd.svg": 80905,
	"./inf.svg": 91992,
	"./info.svg": 18208,
	"./ini.svg": 52595,
	"./inv.svg": 12983,
	"./iso.svg": 37622,
	"./j2.svg": 25615,
	"./jar.svg": 8756,
	"./java.svg": 95964,
	"./jpe.svg": 6441,
	"./jpeg.svg": 17366,
	"./jpg.svg": 82743,
	"./js.svg": 84560,
	"./json.svg": 139,
	"./jsp.svg": 4065,
	"./jsx.svg": 77815,
	"./key.svg": 4430,
	"./kf8.svg": 65292,
	"./kit.svg": 91707,
	"./kmk.svg": 47527,
	"./ksh.svg": 72260,
	"./kt.svg": 33015,
	"./kts.svg": 82904,
	"./kup.svg": 63666,
	"./less.svg": 70373,
	"./lex.svg": 88234,
	"./licx.svg": 37891,
	"./lisp.svg": 87816,
	"./list.svg": 71227,
	"./lit.svg": 84219,
	"./lnk.svg": 31455,
	"./lock.svg": 90422,
	"./log.svg": 95893,
	"./lua.svg": 44453,
	"./m.svg": 87964,
	"./m2v.svg": 32915,
	"./m3u.svg": 67158,
	"./m3u8.svg": 61135,
	"./m4.svg": 82183,
	"./m4a.svg": 44169,
	"./m4r.svg": 15897,
	"./m4v.svg": 83243,
	"./map.svg": 19083,
	"./master.svg": 17892,
	"./mc.svg": 27140,
	"./md.svg": 9256,
	"./mdb.svg": 54420,
	"./mdf.svg": 225,
	"./me.svg": 99145,
	"./mi.svg": 46261,
	"./mid.svg": 35391,
	"./midi.svg": 53346,
	"./mk.svg": 42129,
	"./mkv.svg": 90498,
	"./mm.svg": 66387,
	"./mng.svg": 83386,
	"./mo.svg": 93162,
	"./mobi.svg": 8885,
	"./mod.svg": 80334,
	"./mov.svg": 97081,
	"./mp2.svg": 2177,
	"./mp3.svg": 14260,
	"./mp4.svg": 15014,
	"./mpa.svg": 89593,
	"./mpd.svg": 88564,
	"./mpe.svg": 63183,
	"./mpeg.svg": 10453,
	"./mpg.svg": 25416,
	"./mpga.svg": 20889,
	"./mpp.svg": 37517,
	"./mpt.svg": 39995,
	"./msg.svg": 91940,
	"./msi.svg": 82394,
	"./msu.svg": 43642,
	"./nef.svg": 85193,
	"./nes.svg": 86855,
	"./nfo.svg": 22074,
	"./nix.svg": 51553,
	"./npmignore.svg": 51845,
	"./ocx.svg": 53911,
	"./odb.svg": 25123,
	"./ods.svg": 19503,
	"./odt.svg": 63089,
	"./ogg.svg": 50600,
	"./ogv.svg": 52513,
	"./one.svg": 22084,
	"./ost.svg": 76974,
	"./otf.svg": 18118,
	"./ott.svg": 83425,
	"./ova.svg": 29581,
	"./ovf.svg": 89944,
	"./p12.svg": 91706,
	"./p7b.svg": 62958,
	"./pages.svg": 33065,
	"./part.svg": 99493,
	"./partial.svg": 54934,
	"./pbix.svg": 45533,
	"./pcd.svg": 35201,
	"./pdb.svg": 42897,
	"./pdf.svg": 10123,
	"./pem.svg": 40137,
	"./pfx.svg": 78788,
	"./pgp.svg": 97521,
	"./ph.svg": 33100,
	"./phar.svg": 98736,
	"./php.svg": 27473,
	"./pid.svg": 66979,
	"./pkg.svg": 78719,
	"./pl.svg": 78629,
	"./plist.svg": 84479,
	"./pm.svg": 3217,
	"./png.svg": 20368,
	"./po.svg": 34505,
	"./pom.svg": 68840,
	"./pot.svg": 51138,
	"./potx.svg": 97922,
	"./ppk.svg": 47715,
	"./pps.svg": 16189,
	"./ppsx.svg": 79883,
	"./ppt.svg": 68583,
	"./pptm.svg": 98120,
	"./pptx.svg": 93318,
	"./prop.svg": 6263,
	"./ps.svg": 68105,
	"./ps1.svg": 92657,
	"./psd.svg": 65358,
	"./psp.svg": 48096,
	"./pst.svg": 31769,
	"./pub.svg": 4804,
	"./py.svg": 61172,
	"./pyc.svg": 85420,
	"./qt.svg": 29265,
	"./ra.svg": 20415,
	"./ram.svg": 22491,
	"./rar.svg": 24308,
	"./raw.svg": 87615,
	"./rb.svg": 21884,
	"./rdf.svg": 38105,
	"./rdl.svg": 33849,
	"./reg.svg": 78589,
	"./resx.svg": 95699,
	"./retry.svg": 4029,
	"./rm.svg": 89521,
	"./rom.svg": 65227,
	"./rpm.svg": 15061,
	"./rpt.svg": 79388,
	"./rsa.svg": 79120,
	"./rss.svg": 13919,
	"./rst.svg": 68130,
	"./rtf.svg": 52044,
	"./ru.svg": 96804,
	"./rub.svg": 83898,
	"./sass.svg": 750,
	"./save.svg": 13588,
	"./scss.svg": 13974,
	"./sdf.svg": 21297,
	"./sed.svg": 28136,
	"./sesx.svg": 75844,
	"./sh.svg": 1696,
	"./sit.svg": 9292,
	"./sitemap.svg": 1846,
	"./sketch.svg": 18485,
	"./skin.svg": 27655,
	"./sldm.svg": 57191,
	"./sldx.svg": 76449,
	"./sln.svg": 96360,
	"./sol.svg": 85978,
	"./sphinx.svg": 22064,
	"./sql.svg": 26918,
	"./sqlite.svg": 22530,
	"./srt.svg": 39305,
	"./step.svg": 50731,
	"./stl.svg": 59151,
	"./sub.svg": 91795,
	"./svg.svg": 79409,
	"./swd.svg": 47005,
	"./swf.svg": 89251,
	"./swift.svg": 32529,
	"./swp.svg": 96813,
	"./sys.svg": 23884,
	"./tar.svg": 82890,
	"./tax.svg": 94657,
	"./tcsh.svg": 16799,
	"./tex.svg": 3090,
	"./tfignore.svg": 61788,
	"./tga.svg": 25477,
	"./tgz.svg": 50119,
	"./tif.svg": 94077,
	"./tiff.svg": 6702,
	"./tmp.svg": 83087,
	"./tmx.svg": 88020,
	"./torrent.svg": 79289,
	"./tpl.svg": 4387,
	"./ts.svg": 23201,
	"./tsv.svg": 48184,
	"./tsx.svg": 91762,
	"./ttf.svg": 31421,
	"./twig.svg": 66332,
	"./txt.svg": 89147,
	"./udf.svg": 49497,
	"./vb.svg": 49437,
	"./vbproj.svg": 21350,
	"./vbs.svg": 8572,
	"./vcd.svg": 79759,
	"./vcf.svg": 92646,
	"./vcs.svg": 38287,
	"./vdi.svg": 25276,
	"./vdx.svg": 35792,
	"./vmdk.svg": 46914,
	"./vob.svg": 24637,
	"./vox.svg": 72143,
	"./vscodeignore.svg": 50286,
	"./vsd.svg": 11162,
	"./vss.svg": 3242,
	"./vst.svg": 44968,
	"./vsx.svg": 93300,
	"./vtx.svg": 65221,
	"./war.svg": 34882,
	"./wav.svg": 787,
	"./wbk.svg": 97933,
	"./webinfo.svg": 18564,
	"./webm.svg": 34489,
	"./webp.svg": 57342,
	"./wma.svg": 15498,
	"./wmf.svg": 67014,
	"./wmv.svg": 92749,
	"./woff.svg": 65024,
	"./woff2.svg": 91639,
	"./wpd.svg": 53578,
	"./wps.svg": 41880,
	"./wsf.svg": 42802,
	"./xaml.svg": 41048,
	"./xcf.svg": 39431,
	"./xcodeproj.svg": 34645,
	"./xfl.svg": 18793,
	"./xlb.svg": 6563,
	"./xlc.svg": 60853,
	"./xlm.svg": 2129,
	"./xls.svg": 2285,
	"./xlsb.svg": 18549,
	"./xlsm.svg": 40946,
	"./xlsx.svg": 98320,
	"./xlt.svg": 7662,
	"./xltm.svg": 69382,
	"./xltx.svg": 37280,
	"./xml.svg": 29981,
	"./xpi.svg": 77493,
	"./xps.svg": 85952,
	"./xrb.svg": 66057,
	"./xsd.svg": 71660,
	"./xsl.svg": 52802,
	"./xspf.svg": 50957,
	"./xz.svg": 99551,
	"./yaml.svg": 94378,
	"./yml.svg": 69721,
	"./z.svg": 55857,
	"./zip.svg": 37327,
	"./zsh.svg": 20196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37823;